import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { 
  Overlay, 
  ModalContainer, 
  ModalHeader, 
  ModalBody, 
  ModalFooter, 
  CloseButton,
  ModalDescription,
  ButtonsContainer,
  ConfirmButton,
  CancelButton,
  StyledTable,
  TableHeader,
  TableBody,
  TableRow,
  TableCell,
  CheckboxCell
} from './EntregaKitsLoteModal.styles';

const EntregaKitsLoteModal = ({ isOpen, onClose, selectedGestantes, gestantesData, onConfirm }) => {
  const [selectedInModal, setSelectedInModal] = useState([]);
  const [selectAllModal, setSelectAllModal] = useState(false);

  const gestantesSelecionadas = gestantesData.filter(gestante => 
    selectedGestantes.includes(gestante.gestante_cpf)
  );

  useEffect(() => {
    if (isOpen) {
      const allIds = gestantesSelecionadas.map(g => g.gestante_cpf);
      setSelectedInModal(allIds);
      setSelectAllModal(true);
    }
  }, [isOpen]);

  if (!isOpen) return null;

  const formatCPF = (cpf) => {
    return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
  };

  const handleSelectInModal = (gestanteCpf) => {
    setSelectedInModal((prev) => {
      if (prev.includes(gestanteCpf)) {
        return prev.filter((cpf) => cpf !== gestanteCpf);
      } else {
        return [...prev, gestanteCpf];
      }
    });
    
    const newSelected = selectedInModal.includes(gestanteCpf) 
      ? selectedInModal.filter((cpf) => cpf !== gestanteCpf)
      : [...selectedInModal, gestanteCpf];
    
    setSelectAllModal(newSelected.length === gestantesSelecionadas.length);
  };

  const handleSelectAllModal = () => {
    if (selectAllModal) {
      setSelectedInModal([]);
    } else {
      setSelectedInModal(gestantesSelecionadas.map((gestante) => gestante.gestante_cpf));
    }
    setSelectAllModal(!selectAllModal);
  };

  const handleConfirmWithSelected = () => {
    onConfirm(selectedInModal);
  };

  return (
    <Overlay>
      <ModalContainer>
        <ModalHeader>
          <h2>Entrega de Kits em Lote</h2>
          <CloseButton onClick={onClose}>&times;</CloseButton>
        </ModalHeader>
        <ModalBody>
          <ModalDescription>
            Visualize e gerencie as gestantes selecionadas para a entrega de kits em lote.
          </ModalDescription>
          
          <StyledTable>
            <TableHeader>
              <tr>
                <TableCell as="th">
                  <CheckboxCell>
                    <input 
                      type="checkbox" 
                      checked={selectAllModal}
                      onChange={handleSelectAllModal}
                    />
                  </CheckboxCell>
                </TableCell>
                <TableCell as="th">CPF</TableCell>
                <TableCell as="th">Nome da Gestante</TableCell>
                <TableCell as="th">Cód. Município</TableCell>
                <TableCell as="th">Nome Município</TableCell>
                <TableCell as="th">Status da Gestante</TableCell>
                <TableCell as="th">Número de Filhos</TableCell>
                <TableCell as="th">Número de Kits</TableCell>
              </tr>
            </TableHeader>
            <TableBody>
              {gestantesSelecionadas.map((gestante) => (
                <TableRow key={gestante.gestante_cpf}>
                  <TableCell>
                    <CheckboxCell>
                      <input 
                        type="checkbox" 
                        checked={selectedInModal.includes(gestante.gestante_cpf)}
                        onChange={() => handleSelectInModal(gestante.gestante_cpf)}
                      />
                    </CheckboxCell>
                  </TableCell>
                  <TableCell>{formatCPF(gestante.gestante_cpf)}</TableCell>
                  <TableCell>{gestante.gestante_nome}</TableCell>
                  <TableCell>{gestante.municipio_cod_ibge}</TableCell>
                  <TableCell>{gestante.municipio_nome}</TableCell>
                  <TableCell>{gestante.status_gravidez ? 'Ativa' : 'Inativa'}</TableCell>
                  <TableCell>{gestante.qtd_filhos}</TableCell>
                  <TableCell>{gestante.qtd_filhos}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </StyledTable>
        </ModalBody>
        <ModalFooter>
          <ButtonsContainer>
            <ConfirmButton onClick={handleConfirmWithSelected} disabled={selectedInModal.length === 0}>
              Confirmar e encaminhar kits
            </ConfirmButton>
            <CancelButton onClick={onClose}>
              Cancelar e voltar
            </CancelButton>
          </ButtonsContainer>
        </ModalFooter>
      </ModalContainer>
    </Overlay>
  );
};

EntregaKitsLoteModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  selectedGestantes: PropTypes.array.isRequired,
  gestantesData: PropTypes.array.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

export default EntregaKitsLoteModal;
